module.exports = __webpack_public_path__ + "static/media/logo-2026.e26b2814.svg";